import { useNavigate } from "react-router-dom";

function BackButton(){

const navigate = useNavigate();

return (

<button
style={{
  display:"block",
  background:"#F6C7C8",
  color:"white",
  border:"none",
  padding:"12px 25px",
  borderRadius:"25px",
  fontSize:"18px",
  cursor:"pointer",
  marginBottom:"20px"
}}
onClick={()=>window.history.back()}
>
← Back Home
</button>

)

}

export default BackButton;